import { SliderCard } from '@bnnvara/cards';
import { Article as ArticleIcon } from '@bnnvara/icons/src/components/UserInterfaceIcons/Article';
import { Play } from '@bnnvara/icons/src/components/UserInterfaceIcons/Play';
import PropTypes from 'prop-types';
import React, { Fragment } from 'react';

import Link from '../../components/Link';
import resizeImageSource from '../../helpers/resizeImageSource';

const ComposableBrandSlider = ({
  thumbnail,
  title,
  id,
  url,
  video,
  urlLabel,
  index,
}) => {
  const imageSrc = thumbnail && thumbnail.url;
  const hasImage = thumbnail && !!imageSrc;

  const iconType = video ? <Play /> : <ArticleIcon />;

  return (
    <Fragment>
      <Link
        link={url}
        key={id}
        category="brandSlider"
        action="click"
        label={`slide-${index}`}
      >
        <SliderCard
          thumbnail={
            hasImage
              ? resizeImageSource(imageSrc, 300, 16 / 9)
              : 'data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAfQAAAABCAQAAACC95QfAAAAEUlEQVR42mNkGAWjYBQMewAAB9IAAi/SD5wAAAAASUVORK5CYII='
          }
          icon={iconType}
          title={title}
          brandName={urlLabel}
        />
      </Link>
    </Fragment>
  );
};

ComposableBrandSlider.propTypes = {
  id: PropTypes.string.isRequired,
  urlLabel: PropTypes.string.isRequired,
  title: PropTypes.isRequired,
  url: PropTypes.string.isRequired,
  thumbnail: PropTypes.shape({
    url: PropTypes.string,
  }),
  video: PropTypes.shape({
    id: PropTypes.string,
  }),
  index: PropTypes.number.isRequired,
};

ComposableBrandSlider.defaultProps = {
  thumbnail: null,
  video: null,
};

export default ComposableBrandSlider;
